import {useState,} from "react";
import {convertToEuropeanFormat, formatDateTimeForInput} from "../../logics/helpers";
import {IDetailTransaction} from "../../utils/interfaces/IDetailTransaction";
import {AiOutlineCheck} from "react-icons/ai"
import {ImHourGlass} from "react-icons/im";

interface DetailTransactionRowProps {
    obj: IDetailTransaction,
}

function DetailTransactionRow({obj: initialObj}: DetailTransactionRowProps) {
    const [obj, setObj] = useState<IDetailTransaction>(initialObj)

    return (
        <>
            <td className="mycia_td">
                {obj.order_id}
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.balance.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.net_amount.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.stripe_commission_amount.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.commission_amount.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.type}</span>
            </td>
            <td className="mycia_td" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {obj.type === 'takeaway' || obj.type === 'delivery' || obj.type === 'restaurant' || obj.type === 'refund' ? (
                    obj.rebound_id ? (
                        <AiOutlineCheck className='mt-1'/>
                    ) : (
                        <ImHourGlass className='mt-1'/>
                    )
                ) : (
                    <AiOutlineCheck className='mt-1 text-transparent'/>
                )}
            </td>
            <td className="mycia_td">
                <span className="mr-1">{convertToEuropeanFormat(obj.date)}</span>
            </td>

        </>
    )
}

export default DetailTransactionRow;